import statusLabel from './statusLabel'

const chargebacks = {
  statusLabel,
}

export default chargebacks
